<div class="rounded-2xl overflow-hidden" style="min-width: 340px; max-width: 500px;">
  <!-- Header -->
  <div style="background: linear-gradient(135deg, #fef2f2, #fee2e2); padding: 20px 24px; border-bottom: 2px solid #fecaca;">
    <h2 style="margin: 0; font-size: 1.1rem; font-weight: 700; color: #991b1b; display: flex; align-items: center; gap: 8px;">
      <mat-icon style="font-size: 22px; width: 22px; height: 22px; color: #dc2626;">block</mat-icon>
      Rechazar usuario
    </h2>
    <p style="margin: 6px 0 0; font-size: 0.85rem; color: #7f1d1d;">Selecciona el motivo de rechazo</p>
  </div>

  <!-- Body -->
  <div class="p-5">
    <form [formGroup]="formCompliance" *ngIf="formCompliance">
      <mat-form-field appearance="outline" class="w-full modern-field">
        <mat-label>Comentario compliance</mat-label>
        <mat-select formControlName="comentarioCompliance" name="comentarioCompliance">
          <mat-option>SIN SELECCIONAR</mat-option>
          <mat-option *ngFor="let comentario of comentariosCompliance" [value]="comentario.comentarioID">
            {{ comentario.descripcion | uppercase }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>

    <div class="flex justify-end gap-3 mt-2">
      <button type="button" (click)="onNoClick()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">close</mat-icon>
        Cancelar
      </button>
      <button type="button" [disabled]="!formCompliance.valid" (click)="rechazarUsuario()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: #dc2626; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
        [style.opacity]="!formCompliance.valid ? '0.4' : '1'"
        [style.cursor]="!formCompliance.valid ? 'not-allowed' : 'pointer'"
        onmouseover="this.style.background='#b91c1c'" onmouseout="this.style.background='#dc2626'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">check</mat-icon>
        Rechazar
      </button>
    </div>
  </div>
</div>
